import { Resource, IResource } from './resource';

export interface INotification extends IResource {
}

export class Notification extends Resource implements INotification {
}
